/** @format */

import React from 'react';
import update from 'immutability-helper';
import SuperAgent from 'superagent';

export default function withActiveOrdersHandler(ComponentContainer) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                approving: false,
                disapproving: false,
                disapprovingRequest: false,
                disapproveReason: '',
                expanded: false
            };
        }

        componentDidMount() {}

        handleChange = updateTarget => {
            this.setState(update(this.state, updateTarget));
        };

        handleApprove = () => {
            this.setState({approving: true});
            SuperAgent.post('/account/proofs/approve/' + this.props.id)
                .set('Accept', 'application/json')
                .send({})
                .end((err, response) => {
                    this.props.onUpdateProof(
                        this.props.cartId,
                        response.body.order_id,
                        response.body.id,
                        response.body
                    );
                });
        };

        handleDisapprove = () => {
            this.setState({disapproving: true});
        };

        handleDisapproveConfirm = () => {
            this.setState({disapprovingRequest: true});
            SuperAgent.post('/account/proofs/disapprove/' + this.props.id)
                .set('Accept', 'application/json')
                .send({disapproveReason: this.state.disapproveReason})
                .end((err, response) => {
                    this.props.onUpdateProof(
                        this.props.cartId,
                        response.body.order_id,
                        response.body.id,
                        response.body
                    );
                });
        };

        handleCancelDisapprove = () => {
            this.setState({disapproving: false});
        };

        handleToggle = () => {
            this.setState(state => {
                return {
                    expanded: !state.expanded
                };
            });
        };

        render() {
            const props = {...this.props};

            props.onDisapprove = this.handleDisapprove;
            props.onApprove = this.handleApprove;
            props.onDisapproveConfirm = this.handleDisapproveConfirm;
            props.onCancelDisapprove = this.handleCancelDisapprove;

            props.onChange = this.handleChange;
            props.onToggle = this.handleToggle;

            return <ComponentContainer {...props} {...this.state} />;
        }
    };
}
